// shadcn/ui Tooltip (Radix). Wrap the app in <TooltipProvider> (done in __root).
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({
  className,
  sideOffset = 4,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn('z-50 max-w-xs rounded-md bg-text px-2.5 py-1.5 text-xs text-bg shadow-md', className)}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}
